import { z } from 'zod';
import { BOMItemType } from '../../constants/bom-item-type.js';
import { numericEnumValueStrings, optionalUuidString, requiredEnumIdString, } from '../zod-helpers/index.js';
import { BOM_ITEM_TYPES_REQUIRING_PART } from './bom-item-types-requiring-part/index.js';
import { bomItemNameSchema, bomQuantityStringSchema } from './item-form.js';
import { UOM_REQUIRED_MESSAGE } from './uom-required-message.js';
// The full BOMItemType universe, as strings — matches the form's string-valued typeId directly.
const ALL_BOM_ITEM_TYPE_ID_STRINGS = numericEnumValueStrings(BOMItemType);
export const bomItemCreateFormSchema = z
    .object({
    // Required-ness by typeId is enforced below, mirroring addBomItemInputSchema's server-side rule.
    partId: optionalUuidString('Invalid part selection.'),
    name: bomItemNameSchema,
    quantity: bomQuantityStringSchema,
    uomId: optionalUuidString('Invalid UOM selection.'),
    typeId: requiredEnumIdString(BOMItemType, 'Type is required.', 'Invalid BOM item type.'),
})
    .superRefine((values, context) => {
    const typeId = Number(values.typeId);
    // An unset or invalid typeId defaults to still requiring Part — only an explicit partless type (Note/Service) waives it.
    const requiresPart = !ALL_BOM_ITEM_TYPE_ID_STRINGS.has(values.typeId) || BOM_ITEM_TYPES_REQUIRING_PART.has(typeId);
    if (requiresPart && !values.partId?.trim()) {
        context.addIssue({ code: 'custom', message: 'Part is required.', path: ['partId'] });
    }
    if (requiresPart && !values.uomId?.trim()) {
        context.addIssue({ code: 'custom', message: UOM_REQUIRED_MESSAGE, path: ['uomId'] });
    }
});
//# sourceMappingURL=create-item-form.js.map